import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ConfigService, EntityService } from 'viggo-sistemas-core-web';
import { convertDateToMaskTimezone } from '../../../../shared/utils/date';
import { Agenda } from '../../model/vendedor.model';

import { Observable } from 'rxjs';
import {
  EventoPerdeGanha,
  EventoPerdeGanhaResult,
  IVendedor
} from '../../model/vendedor.model';

@Injectable()
/**
 * service que faz as interações com o backend
 * comunicando via http com o backend para trocar informações
 */
export class VendedorService extends EntityService<IVendedor> {
  constructor(protected configService: ConfigService) {
    super({
      baseEntityEndPoint: 'vendedor',
      pluralBaseEntityEndPoint: 'vendedores',
      urlBackend: configService.backendURL
    });
  }
  /**
   * Altera o status de `active` da entidade repassada necessitando o array de parcelas
   * @param entity informações da entidade
   */
  public changeActive(entity: IVendedor) {
    return this.update({
      active: entity.active,
      id: entity.id,
      carteira: entity.carteira
    } as IVendedor);
  }

  /**
   * Responsável por gerar um PDF de positivação do vendedor
   */
  relatorioPositivacao(
    faixa_data: { de: string; ate: string },
    vendedor_id: string,
    domain_id: string,
    municipio_id?: string
  ): Observable<any> {
    var url = `${this.baseURL}/${vendedor_id}/relatorio_positivacao`;
    var params = new HttpParams();

    if (faixa_data) {
      params = params
        .append('de', convertDateToMaskTimezone(faixa_data.de))
        .append('ate', convertDateToMaskTimezone(faixa_data.ate));
    }

    if (domain_id) params = params.append('domain_id', domain_id);

    if (municipio_id) params = params.append('municipio_id', municipio_id);

    return this.http.get(url, {
      headers: this.getHeader(),
      params: params,
      responseType: 'blob'
    });
  }

  /**
   * Responsável por construir os dados de agendamento de um vendedor
   */
  agendamento(
    faixa_data: { de: string; ate: string },
    vendedor_id: string,
    domain_id: string
  ) {
    var url = `${this.baseURL}/agenda`;
    var params = new HttpParams();

    if (faixa_data) {
      params = params.append('de', faixa_data.de).append('ate', faixa_data.ate);
    }

    if (vendedor_id) params = params.append('vendedor_id', vendedor_id);

    if (domain_id) params = params.append('domain_id', domain_id);

    return this.http.get<{ agenda: Agenda[] }>(url, {
      params: params,
      headers: this.getHeader()
    });
  }

  /**
   * Responsável por enviar um evento de atualização do perde ganha
   * @param vendedor_id
   * @param evento
   * @returns
   */
  atualizarSaldoPerdeGanha(vendedor_id: string, evento: EventoPerdeGanha) {
    const url = `${this.baseURL}/${vendedor_id}/reg_vendedor_perde_ganha_evento`;
    return this.http.put<{ evento: EventoPerdeGanhaResult }>(url, evento, {
      headers: this.getHeader()
    });
  }

  /**
   * Pega clientes disponiveis e selecionados para um vendedor e retorna eles paginados
   * @param vendedor_id
   * @param pagination
   * @param include
   * @param where
   * @returns
   */
  clientesCarteira(
    anotherUrl: boolean,
    vendedor_id: string,
    pagination: {
      require_pagination?: boolean;
      page_size?: number;
      page?: number;
    },
    include: string[],
    where?: string | { field: string; value: string }
  ) {
    var url = anotherUrl
      ? `${this.baseURL}/${vendedor_id}/cliente_disponiveis`
      : `${this.baseURL}/${vendedor_id}/clientes`;
    var params = new HttpParams();

    if (pagination) {
      params = params
        .append('page', pagination.page)
        .append('page_size', pagination.page_size)
        .append('require_pagination', pagination.require_pagination);
    }

    if (include) params = params.append('include', include.join(','));

    if (where) {
      if (typeof where === 'object')
        params = params.append(`${where.field}`, where.value);
      else params = params.append('cliente_id', where);
    }

    return this.http.get<any>(url, {
      params: params,
      headers: this.getHeader()
    });
  }
}
